import { authorizedInstance } from "../config/axios"

export const getOrderStatistics = async (data = {}) => {
  const response = await authorizedInstance.post("/statistics/order", data)
  return response.data
}

export const getOrderStatsForPatientIssuer = async (payload = {}) => {
  const response = await authorizedInstance.get(
    `statistics/order-stats?patientIssuer=${payload.patientIssuer}&from=${payload.from}&to=${payload.to}`
  )
  return response.data
}

export const getOrderErrorStatistics = async (data = {}) => {
  const response = await authorizedInstance.post(
    "/statistics/order-error",
    data
  )
  return response.data
}

export const getOrderResultStatistics = async (data = {}) => {
  const response = await authorizedInstance.post(
    "/statistics/order-results",
    data
  )
  return response.data
}

export const getResultStatsForPatientIssuer = async (payload = {}) => {
  const response = await authorizedInstance.get(
    `statistics/result-stats?patientIssuer=${payload.patientIssuer}&from=${payload.from}&to=${payload.to}`
  )
  return response.data
}

export const getPatientIssuers = async (data = {}) => {
  const response = await authorizedInstance.get(
    "/statistics/patient-issuers",
    data
  )
  return response.data
}

export const getDashboardStatistics = async (data = {}) => {
  const response = await authorizedInstance.get("/statistics/dashboard-stats", {
    params: data,
  })
  return response.data
}
